module.exports = __webpack_public_path__ + "static/media/1.9df3c2f4.png";